import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Button, Table } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";


const Banners = () => {
  const [banners, setBanners] = useState([]);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
  title: "",
  subtitle: "",
  desc: "",
  image: null,
  status: true,
  titleColor: "#ffffff",
  subtitleColor: "#FFD600",
  descColor: "#f1f1f1",
});

  const [preview, setPreview] = useState(null);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    // const res = await axios.get("https://api.themysoreoils.com/api/banners");
    const res = await axios.get("https://api.themysoreoils.com/api/banners");
    setBanners(res.data);
  };

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (type === "file") {
      setFormData({ ...formData, image: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else if (type === "checkbox") {
      setFormData({ ...formData, status: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const data = new FormData();
  data.append("title", formData.title);
  data.append("subtitle", formData.subtitle);
  data.append("desc", formData.desc);
  data.append("status", formData.status);
   data.append("titleColor", formData.titleColor);
  data.append("subtitleColor", formData.subtitleColor);
  data.append("descColor", formData.descColor);

  if (formData.image) {
    data.append("image", formData.image);
  }

  if (editId) {
    // UPDATE
    await axios.put(
      // `https://api.themysoreoils.com/api/banners/${editId}`,
      `https://api.themysoreoils.com/api/banners/${editId}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } else {
    // CREATE
    await axios.post(
      // "https://api.themysoreoils.com/api/banners",
      "https://api.themysoreoils.com/api/banners",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

setFormData({
  title: "",
  subtitle: "",
  desc: "",
  image: null,
  status: true,
  titleColor: "#ffffff",
  subtitleColor: "#FFD600",
  descColor: "#f1f1f1",
});

  setPreview(null);
  setEditId(null);

  fetchBanners();
};



  const toggleStatus = async (id) => {
    await axios.patch(
      // `https://api.themysoreoils.com/api/banners/${id}/status`
    `https://api.themysoreoils.com/api/banners/${id}/status`
    );
    fetchBanners();
  };

  const deleteBanner = async (id) => {
    if (window.confirm("Delete this banner?")) {
      await axios.delete(
        // `https://api.themysoreoils.com/api/banners/${id}`
        `https://api.themysoreoils.com/api/banners/${id}`
      );
      fetchBanners();
    }
  };

const handleEdit = (banner) => {
  setFormData({
    title: banner.title,
    subtitle: banner.subtitle,
    desc: banner.desc,
    image: null,
    status: banner.status,
    titleColor: banner.titleColor || "#ffffff",
    subtitleColor: banner.subtitleColor || "#FFD600",
    descColor: banner.descColor || "#f1f1f1",
  });

  // setPreview(`https://api.themysoreoils.com${banner.image}`);
  setPreview(banner.image);

  setEditId(banner._id);
};


  return (
    <div className="container mt-4">
      <h3 className="mb-3">Banner Management</h3>

      {/* Add Banner */}
      <Form onSubmit={handleSubmit} className="mb-4">
        <Form.Group className="mb-2">
          <Form.Label>Banner Title</Form.Label>
          <Form.Control
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </Form.Group>

      <Form.Group className="mb-2">
  <Form.Label>Banner Subtitle</Form.Label>
  <Form.Control
    type="text"
    name="subtitle"
    value={formData.subtitle}
    onChange={handleChange}
  />
</Form.Group>


         <Form.Group className="mb-2">
         <Form.Label>Banner Description</Form.Label>
         <Form.Control
            type="text"
            name="desc"
            value={formData.desc}
            onChange={handleChange}
            required
          />
          </Form.Group>

        <Form.Group className="mb-2">
          <Form.Label>Banner Image</Form.Label>
   <Form.Control
  type="file"
  name="image"
  accept="image/*"
  onChange={handleChange}
  required={!editId}
/>


        </Form.Group>

        <Form.Group className="mb-2">
  <Form.Label>Title Color</Form.Label>
  <Form.Control
    type="color"
    name="titleColor"
    value={formData.titleColor}
    onChange={handleChange}
  />
</Form.Group>

<Form.Group className="mb-2">
  <Form.Label>Subtitle Color</Form.Label>
  <Form.Control
    type="color"
    name="subtitleColor"
    value={formData.subtitleColor}
    onChange={handleChange}
  />
</Form.Group>


        {preview && (
          <img
            src={preview}
            alt="preview"
            style={{ height: "80px", marginBottom: "10px" }}
          />
        )}

        <Form.Check
          type="checkbox"
          label="Active"
          checked={formData.status}
          onChange={handleChange}
          name="status"
          className="mb-2"
        />

      <Button type="submit">
  {editId ? "Update Banner" : "Add Banner"}
</Button>

      </Form>

      {/* Banner List */}
      <Table bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Preview</th>
            <th>Title</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {banners.map((banner, index) => (
            <tr key={banner._id}>
              <td>{index + 1}</td>
              <td>
                {/* <img
  src={`https://api.themysoreoils.com${banner.image}`}
  alt=""
  style={{ height: "50px" }}
/> */}

<img
  src={banner.image}
  alt=""
  style={{ height: "50px" }}
/>

              </td>
              <td>{banner.title}</td>
              <td>{banner.desc}</td>
              <td>
                <Button
                  size="sm"
                  variant={banner.status ? "success" : "secondary"}
                  onClick={() => toggleStatus(banner._id)}
                >
                  {banner.status ? "Active" : "Inactive"}
                </Button>
                <Button
  size="sm"
  variant="primary"
  className="me-2"
  onClick={() => handleEdit(banner)}
  style={{marginLeft:"10px"}}
>
  Edit
</Button>

              </td>
              <td>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => deleteBanner(banner._id)}
                >
                  <FaTrash/>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Banners;
